// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alignChildParent {
    text-align: left;
}

.alignChild {
    vertical-align: middle;
    display: inline-block;
    padding: 0 8px;
}

.alignChild a {
    text-decoration: none;    
}`, "",{"version":3,"sources":["webpack://./src/components/search/SavedQueryRow.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".alignChildParent {\r\n    text-align: left;\r\n}\r\n\r\n.alignChild {\r\n    vertical-align: middle;\r\n    display: inline-block;\r\n    padding: 0 8px;\r\n}\r\n\r\n.alignChild a {\r\n    text-decoration: none;    \r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
